// src/router/notas-fiscais-prestador.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['peopleCulture', 'colaborador']


const novaNotaFiscalPrestadorBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Notas fiscais prestador',
        to: 'NotasFiscaisPrestadorList'
    }
]

export default [
    {
        path: '/notas-fiscais-prestador',
        name: 'NotasFiscaisPrestadorList',
        component: () => import('@/views/PeopleCulture/NotasFiscaisPrestador/ListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Notas fiscais prestador',
            breadcrumb: novaNotaFiscalPrestadorBreadCrumb
        },
    },
    {
        path: '/notas-fiscais-prestador/novo',
        name: 'NotasFiscaisPrestador',
        component: () => import('@/views/PeopleCulture/NotasFiscaisPrestador/NovoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Notas fiscais prestador',
            breadcrumb: [
                ...novaNotaFiscalPrestadorBreadCrumb,
                {
                    label: 'Notas fiscais prestador',
                    to: 'NotasFiscaisPrestador'
                }
            ]
        }
    },
    {
        path: '/notas-fiscais-prestador/:id/edit',
        name: 'NotasFiscaisPrestadorEdit',
        component: () => import('@/views/PeopleCulture/NotasFiscaisPrestador/NovoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes das notas fiscais do prestador',
            breadcrumb: [
                ...novaNotaFiscalPrestadorBreadCrumb,
                {
                    label: 'Notas fiscais prestador',
                    to: 'NotasFiscaisPrestador'
                }
            ]
        }
    }
];
